


import React, { useState } from 'react';


export default function ({id, linked_category_id, content}) {
    // console.log(props)
    return (<div className="text-list item draggable-handle" key={id}>
        {/* <h3>{content && content.name && content.name.en}</h3> */}
        <ul className="text-list__list">
            {content && content.products && content.products.map((dish, index) => {
                return (
                    <li className={"text-list-item"} key={dish.id}>
                        <div className="meta">
                        <span className="name">{dish.name ? dish.name.en : ""}</span>
                        {Number(dish.price) ? <span className="price">{dish.price}</span> : null}
                        {!Number(dish.price) && dish.price ? <span className="price-display">{dish.price}</span> : null}
                        </div>
                        <div className="dish__description">
                        <span>{dish.description ? dish.description.en : ""}</span>
                        </div>
                    </li>
                )
            })}
        </ul>
    </div>)
}